import { useMemo } from 'react';

type OptionObject = {
  label: string;
  value: string;
};

type UseMergeValueIntoOptionsParams = {
  currentOption?: OptionObject | null;
  options: OptionObject[];
  valueKey?: keyof OptionObject;
  labelKey?: keyof OptionObject;
};

export const useMergeValueIntoOptions = ({
  currentOption,
  options,
  valueKey = 'value',
  labelKey = 'label',
}: UseMergeValueIntoOptionsParams): OptionObject[] => {
  return useMemo(() => {
    if (!currentOption || !currentOption[valueKey]) {
      return options;
    }

    const valueToCheck = currentOption[valueKey];
    const labelToUse = currentOption[labelKey];

    const valueExists = options.some(
      (option) => option[valueKey] === valueToCheck,
    );

    if (valueExists) {
      return options;
    }

    const missingOption: OptionObject = {
      [labelKey]: labelToUse,
      [valueKey]: valueToCheck,
    } as OptionObject;

    return [missingOption, ...options];
  }, [currentOption, options, valueKey, labelKey]);
};
